import {commonConfirmationBulkDelete} from "../../../../hoc/commonConfirmationBulkDelete";

const BulkTransferDelete = commonConfirmationBulkDelete('Transfer');
export default BulkTransferDelete;
